<article class="hw-card" [routerLink]="['/handwerker', handwerker().id]">
  <!-- Cover image area — echtes Cover oder Monogramm-Fallback (nie grauer Leerblock). -->
  <div class="hw-card__cover">
    @if (handwerker().coverImageUrl) {
      <img class="hw-card__cover-img" [src]="handwerker().coverImageUrl!" [alt]="handwerker().vorname" loading="lazy" />
    } @else {
      <div class="hw-card__cover-placeholder" aria-hidden="true">
        <span class="hw-card__monogram">{{ initial() }}</span>
      </div>
    }
    <button class="hw-card__fav" (click)="$event.stopPropagation()" aria-label="Merken" type="button">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-8-5-8-11a5 5 0 0 1 8-4 5 5 0 0 1 8 4c0 6-8 11-8 11Z"/></svg>
    </button>
    @if (handwerker().badge; as badge) {
      <span class="hw-card__badge-slot">
        <app-verifizierung-badge [badge]="badge" variant="pill" />
      </span>
    } @else if (handwerker().isVerified) {
      <span class="hw-card__verified" title="Identität und Gewerbeschein geprüft">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 2 4 5v7c0 5 4 9 8 10 4-1 8-5 8-10V5l-8-3Z"/>
          <path d="m9 12 2 2 4-4"/>
        </svg>
        Verifiziert
      </span>
    }
  </div>

  <!-- Card body -->
  <div class="hw-card__body">
    <div class="hw-card__top-row">
      <h3 class="hw-card__name">
        {{ handwerker().vorname }}
        @if (handwerker().nachname) { {{ handwerker().nachname }} }
      </h3>
      @if (handwerker().durchschnittsBewertung !== null) {
        <span class="hw-card__rating">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="m12 2 2.9 6.5L22 9.6l-5.3 4.9L18 22l-6-3.3L6 22l1.3-7.5L2 9.6l7.1-1.1L12 2z"/></svg>
          {{ handwerker().durchschnittsBewertung | number:'1.1-1' }}
        </span>
      }
    </div>

    <p class="hw-card__meta">
      @for (g of sichtbareGewerke(); track g; let last = $last) {
        {{ g }}@if (!last) { · }
      }
      @if (weitereGewerke() > 0) {
        · +{{ weitereGewerke() }}
      }
      @if (handwerker().entfernungKm !== null) {
        · {{ handwerker().entfernungKm | number:'1.0-1' }} km
      }
    </p>

    <p class="hw-card__price">
      <strong>{{ handwerker().stundensatz | currency:'EUR':'symbol':'1.0-0' }}</strong>
      <span>/Std. · inkl. USt</span>
    </p>
  </div>
</article>
